import FlexBox from '@/atomic-components/FlexBox';
import { Box, Button, Divider, Drawer, Grid } from '@mui/material';
import { LencoTypography } from '@/atomic-components/LencoTypography';
import CloseIcon from '@/assets/CloseIcon.svg';
import { getColor } from '@/utils/theme/colors';
import { LencoImage } from '@/atomic-components/Image';
import { ICartItem } from '@/services/cart/models/cart';
import CartItemSummary from '../CartItem/CartItemSummary';
import LencoButton from '@/atomic-components/LencoButton';

type TRemoveCartItemConfirmationDrawerProps = {
	open: boolean;
	removingItem: boolean;
	movingItemToWishlist: boolean;
	onClose: () => void;
	onConfirm: () => void;
	onReject: () => void;
	itemToDelete?: ICartItem;
};

const RemoveCartItemConfirmationDrawer = (
	props: TRemoveCartItemConfirmationDrawerProps
) => {
	return (
		<Drawer anchor='right' open={props.open} onClose={props.onClose}>
			<Box sx={{ width: '460px', backgroundColor: 'white' }}>
				{props.itemToDelete && (
					<Grid container justifyContent={'center'}>
						<Grid item md={10} pt='87px'>
							<FlexBox
								alignItems={'center'}
								justifyContent='space-between'
								mb='30px'
							>
								<LencoTypography variant='H11_Medium'>
									Remove item from Cart
								</LencoTypography>
								<Box className='cursor-pointer' onClick={props.onClose}>
									<CloseIcon />
								</Box>
							</FlexBox>
							<Divider />
							<LencoTypography
								variant='P_Regular'
								color={getColor('Gray -2')}
								mt='23px'
							>
								Are you sure you want to remove this product from the cart?{' '}
							</LencoTypography>
							<FlexBox mt='37px'>
								<Box width={'113px'} mr='16px'>
									<LencoImage
										aspectRatio={113 / 77}
										url={props.itemToDelete?.product?.image as string}
									/>
								</Box>
								<CartItemSummary item={props.itemToDelete as ICartItem} />
							</FlexBox>
							<FlexBox fullWidth justifyContent={'space-between'} mt='50px'>
								<Box width={'48%'}>
									<LencoButton
										isLoading={props.removingItem}
										fullWidth
										variant='contained'
										color='secondary'
										onClick={props.onConfirm}
										circularProgressProps={{
											size: 26,
										}}
									>
										REMOVE IT 
									</LencoButton>
								</Box>
								<Box width={'48%'}>
									<LencoButton
										isLoading={props.movingItemToWishlist}
										fullWidth
										variant='contained'
										onClick={props.onReject}
										circularProgressProps={{
											size: 28,
										}}
									>
										MOVE TO WISHLIST
									</LencoButton>
								</Box>
							</FlexBox>
						</Grid>
					</Grid>
				)}
			</Box>
		</Drawer>
	);
};

export default RemoveCartItemConfirmationDrawer;
